export default __webpack_public_path__ + "static/media/rnr-sports-table-20-cn.669e986c.webp";